import { render, staticRenderFns } from "./imChat.vue?vue&type=template&id=28208a55"
import script from "./imChat.vue?vue&type=script&lang=js"
export * from "./imChat.vue?vue&type=script&lang=js"
import style0 from "./imChat.vue?vue&type=style&index=0&id=28208a55&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports